import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { AuthClient } from 'features/auth/AuthClient';

export const createAuthorizedBaseQuery = (baseUrl: string) =>
    fetchBaseQuery({
        baseUrl,
        prepareHeaders: async (headers, { extra }) => {
            // `createAppStore` always injects the AuthClient as the thunk extra argument.
            const accessToken = await (extra as AuthClient).getAccessToken();

            if (accessToken !== null) {
                headers.set('authorization', `Bearer ${accessToken}`);
            }

            return headers;
        },
    });
